<template>
  <div>
    <!-- <div class="filter-row"></div> -->
    <Row style="margin-bottom:10px">
      <Col span="6">
        <!-- <Button :icon="!this.selectAllStatus?'ios-checkbox-outline':'ios-checkbox'" size="small" @click="handleSelectAll"></Button> -->
        <Button size="small" @click="handleSelectAll"><Checkbox :value="this.selectAllStatus" @on-change="handleSelectAll" size="small">全选</Checkbox></Button>
        <Divider type="vertical" />
        <Button icon="md-play" :disabled="selectIds.length==0" size="small" @click="publishAllData">发布</Button>
        <Button icon="md-undo" :disabled="selectIds.length==0" size="small" @click="undoAllData">撤消</Button>
      </Col>
      <Col span="18" style="text-align:right">
        <!-- <Tag v-if="attendCount>0">本月考勤数据：{{attendCount}}条</Tag>
        <Tag v-else>本月没有考勤数据</Tag> -->
        时间：
        <DatePicker
          :open="open"
          :value="date"
          confirm
          type="month"
          format="yyyy-M"
          @on-change="dateChange"
          @on-clear="handleClear"
          @on-ok="handleOk">
          <Button href="javascript:void(0)" size="small" @click="handleClick" icon="md-calendar">
              <template>{{ date }}</template>
          </Button>
        </DatePicker>
        <Select v-model="selectDids" class="did-select" @on-change="didChange" placeholder="选择部门" size="small" style="width:140px;text-align:left" multiple>
          <Option v-for="(item, ind) in $store.state.department" :key="ind" :value="item.value">{{item.label}}</Option>
        </Select>
        <Divider type="vertical"/>
        <Poptip trigger="hover" :content="attendCount>0?`本月考勤数据：${attendCount}条`:'本月没有考勤数据无法操作'">
          <Button @click="createSalary" :disabled="attendCount==0" size="small" icon="md-cash">生成薪资数据</Button>
        </Poptip>
        &nbsp;
        <Button @click="uploadModal=true" size="small" icon="md-cloud-upload">上传附表</Button>
        <Divider type="vertical"/>
        <Button @click="exportData" size="small" icon="md-cloud-download">导出本月数据</Button>
      </Col>
    </Row>
    <Table border ref="salarysTable" @on-selection-change="selectChange" :columns="columns" class="salarys" :data="salarys.data"></Table>
    <Row style="margin-top:10px">
      <Col span="24">
        <!-- <Button :icon="!this.selectAllStatus?'ios-checkbox-outline':'ios-checkbox'" size="small" @click="handleSelectAll"></Button> -->
        <Button size="small" @click="handleSelectAll"><Checkbox :value="this.selectAllStatus" @on-change="handleSelectAll" size="small">全选</Checkbox></Button>
        <Divider type="vertical" />
        <Button icon="md-play" :disabled="selectIds.length==0" size="small" @click="publishAllData">发布</Button>
        <Button icon="md-undo" :disabled="selectIds.length==0" size="small" @click="undoAllData">撤消</Button>
      </Col>
    </Row>
    <div class="pager" v-if="salarys.data.length>0">
      <Page :page-size="Number(salarys.per_page)" :total="salarys.total" class="pager" show-total show-sizer @on-page-size-change="pageSizeChange" :page-size-opts="[40, 60, 100]" @on-change="pagerChange"></Page>
    </div>
    <!-- <Modal title="薪资数据" :styles="{'height': '100%', 'top': 0}" :width="100" v-model="salaryModal">
      <footer slot="footer"></footer>
    </Modal> -->
    <Modal title="选择时间" v-model="createdSalaryModal" width="250" footer-hide>
      <template v-if="createStep==1">
        <DatePicker @on-change="dateChange" :value="date" format="yyyy-M" type="month" placement="bottom-end" placeholder="选择时间" style="width: 215px"></DatePicker>
        <div style="border-bottom:1px solid #eee;margin:10px 0"></div>
        <Button type="primary"  @click="submit" long>确定创建</Button>
      </template>
      <template v-else-if="createStep==2">
        <div style="text-align:center">请稍等，处理中...</div>
      </template>
      <template v-else>
        <div style="text-align:center;margin-bottom:10px">{{createTip}}</div>
        <div style="text-align:center"><Button  @click="createStep=1" long>重试</Button></div>
      </template>
    </Modal>
    <Modal title="其他费用" v-model="attachSalaryModal" width="350" footer-hide>
      <Form ref="formValidate" :model="attach" :label-width="80">
          <FormItem label="时间：">
          {{attach.year}} 年 {{attach.month}} 月
        </FormItem>
        <FormItem label="金额：">
          <InputNumber v-model="attach.value" />
        </FormItem>
        <FormItem label="备注：">
          <Input v-model="attach.remarks" type="textarea" />
        </FormItem>
        <FormItem label="">
          <Button type="primary" icon="md-checkmark-circle" @click="saveAttach">确定</Button>
          <Button type="error" icon="md-trash" @click="deleteAttach">删除</Button>
        </FormItem>
      </Form>
    </Modal>
    <Modal
        v-model="uploadModal"
        title="导入基础数据"
        width="340"
        :mask-closable="false">
        <div>
          <Upload
            ref="upload"
            :show-upload-list="false"
            :on-success="handleSalarySuccess"
            :format="['xls','xlsx']"
            :max-size="10048"
            :data="{file_type:'salary_table'}"
            :headers="uploadHeaders"
            :on-format-error="handleFormatError"
            :on-exceeded-size="handleMaxSize"
            :before-upload="handleBeforeUpload"
            type="drag"
            v-show="uploadState==0"
            :action="uploadApiPath"
             class="upload-item" style="margin:0">
              <div style="width:100%;padding: 20px 0">
                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                <p>选择文件</p>
              </div>
          </Upload>
          <div v-show="uploadState==1" style="text-align:center">正在努力更新，请稍等</div>
        </div>
        <div slot="footer">
          <a href="http://api.zjyumai.com/uploads/薪资附表模版.xlsx" target="_blank" style="color:#999">模版下载 <Icon type="ios-cloud-download" size="12"></Icon></a>
        </div>
    </Modal>
   </div>
</template>

<script>
import {post, fetch, del} from '../fetch/api'
// import draggable from 'vuedraggable'

export default {
  name: 'AnalysisForm',
  props: {
  },
  data () {
    let token = localStorage.getItem('token')
    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    // let day = date.getDate()

    return {
      users: {
        data: []
      },
      timeout: null,
      fields: [],
      monthDay: 12,
      attendModal: false,
      uploadModal: false,
      salaryModal: true,
      createdSalaryModal: false,
      createStep: 1,
      createTip: '',
      selectIds: [],
      selectUserIds: [],
      selectDids: [],
      department: [],
      params: {
        year: year,
        page_size: 40,
        month: month,
        page: 1
      },
      open: false,
      date: year + '-' + month,
      selectDate: year + '-' + month,
      salarys: {
        data: []
      },
      attends: [],
      attachSalaryModal: false,
      selectAllStatus: false,
      attach: {
        id: 0,
        user_id: 0,
        year: year,
        month: month,
        value: 0,
        remarks: ''
      },
      uploadList: [],
      attendCount: 0,
      uploadState: 0,
      uploadApiPath: '/api/users/upload/salary/attach',
      uploadHeaders: {
        'Authorization': `Bearer ${token}`
      },
      days: [
        {name: '出勤天数', label: '$cqday'},
        {name: '项目地上班天数', label: '$xmday'},
        {name: '加班天数', label: '$jbday'},
        {name: '实习天数', label: '$sxday'},
        {name: '培训天数', label: '$pxday'},
        {name: '假期天数', label: '$jqday'},
        {name: '年休天数', label: '$nxday'},
        {name: '婚产天数', label: '$hcjday'},
        {name: '病假天数', label: '$bjday'},
        {name: '丧假天数', label: '$sjday'},
        {name: '事假天数', label: '$sjday'},
        {name: '旷工天数', label: '$kgday'},
        {name: '离职天数', label: '$lzday'},
        {name: '招聘天数', label: '$zpday'}
      ],
      columns: [
        {
          type: 'selection',
          fixed: 'left',
          width: 60,
          align: 'center'
        },
        {
          title: '姓名',
          key: 'username',
          width: 100,
          fixed: 'left',
          render: (h, params) => {
            return h('div', params.row.user.username)
          }
        },
        {
          title: '薪资',
          align: 'center',
          children: [
            {
              title: '应发合计',
              key: 'pay_total',
              align: 'center',
              width: 140,
              render: (h, params) => {
                return h('div', [
                  h('Poptip', {class: 'price_info', props: {trigger: 'hover', content: params.row.pay_detail}}, '¥ ' + params.row.pay_total.toFixed(2))
                ])
              }
            },
            {
              title: '应扣合计',
              key: 'deduct_total',
              align: 'center',
              width: 140,
              render: (h, params) => {
                return h('div', [
                  h('Poptip', {class: 'price_info', props: {trigger: 'hover', content: params.row.deduct_detail}}, '¥ ' + params.row.pay_total.toFixed(2))
                ])
              }
            },
            {
              title: '本月实发薪资',
              key: 'total',
              className: 'highlight',
              width: 140,
              render: (h, params) => {
                return h('Poptip', {class: 'price_info', props: {trigger: 'hover', content: '应发 - 应扣'}}, '¥ ' + (params.row.pay_total - params.row.deduct_total).toFixed(2))
              }
            },
            {
              title: '可报销',
              key: 'expense_total',
              align: 'center',
              width: 140,
              render: (h, params) => {
                return h('div', [
                  h('Poptip', {class: 'price_info', props: {trigger: 'hover', content: params.row.expense_detail}}, '¥ ' + params.row.expense_total.toFixed(2))
                ])
              }
            },
            {
              title: '公司社保部分',
              width: 140,
              render: (h, params) => {
                return h('div', '¥ ' + Number(params.row.social_security).toFixed(2))
              }
            },
            {
              title: '代缴税费',
              width: 140,
              render: (h, params) => {
                return h('div', '¥ ' + Number(params.row.taxation).toFixed(2))
              }
            }
          ]
        },
        {
          title: '其他费用',
          align: 'center',
          children: [
            {
              title: '费用',
              className: 'other-salary-td',
              width: 140,
              render: (h, params) => {
                let col = []
                let attach = params.row.attach
                if (attach.length > 0) {
                  for (var k in attach) {
                    if (attach.hasOwnProperty(k)) {
                      col.push(h('div', {class: 'other-salary-item', props: {span: 24}}, attach[k].value))
                    }
                  }
                } else {
                  col.push(h('div', {class: 'other-salary-item'}, '--'))
                }
                return h('div', col)
              }
            },
            {
              title: '备注',
              width: 140,
              className: 'other-salary-td',
              ellipsis: true,
              render: (h, params) => {
                let col = []
                let attach = params.row.attach
                if (attach.length > 0) {
                  for (var k in attach) {
                    if (attach.hasOwnProperty(k)) {
                      col.push(h('div', {class: 'other-salary-item'}, [h('Poptip', {props: {trigger: 'hover', 'word-wrap': true, content: attach[k].remarks, placement: 'top-start'}}, attach[k].remarks, h('div', {props: {span: 24}}, attach[k].remarks))]))
                    }
                  }
                } else {
                  col.push(h('div', {class: 'other-salary-item'}, '--'))
                }
                return h('div', col)
              }
            },
            {
              title: '操作',
              width: 110,
              className: 'other-salary-td',
              render: (h, params) => {
                let col = []
                let attach = params.row.attach
                if (attach.length > 0) {
                  for (var k in attach) {
                    if (attach.hasOwnProperty(k)) {
                      col.push(h('div', {class: 'other-salary-item'},
                        [
                          h('Button', {
                            props: {size: 'small', icon: 'md-create'},
                            on: {
                              click: () => {
                                this.editAttach(attach[k])
                              }
                            }
                          }),
                          h('Divider', {props: {type: 'vertical'}}),
                          h('Button', {
                            props: {
                              size: 'small',
                              icon: 'md-add'
                            },
                            on: {
                              click: () => {
                                this.setAttach(params.row.user_id)
                              }
                            }
                          })
                        ]
                      ))
                    }
                  }
                } else {
                  col.push(h('div', {class: 'other-salary-item'},
                    [
                      h('Button', {
                        props: {size: 'small', disabled: true, icon: 'md-create'},
                        on: {
                          click: () => {
                            this.editAttach(attach[k])
                          }
                        }
                      }),
                      h('Divider', {props: {type: 'vertical'}}),
                      h('Button', {
                        props: {
                          size: 'small',
                          icon: 'md-add'
                        },
                        on: {
                          click: () => {
                            this.setAttach(params.row.user_id)
                          }
                        }
                      })
                    ]
                  ))
                }
                return h('div', col)
              }
            }
          ]
        },
        {
          title: '本月薪资总额',
          width: 140,
          key: 'total',
          className: 'highlight',
          render: (h, params) => {
            let attach = params.row.attach
            let attachMoney = 0
            if (attach.length > 0) {
              for (var k in attach) {
                if (attach.hasOwnProperty(k)) {
                  attachMoney += attach[k].value
                }
              }
            }
            return h('div', '¥ ' + (params.row.total + attachMoney).toFixed(2))
          }
        },
        {
          title: '状态',
          width: 110,
          fixed: 'right',
          render: (h, params) => {
            let status = ['待发布', '已发布', '已撤回', '错误']
            let statusType = ['default', 'green', 'warning', 'error']
            let col = [h('Tag', {props: {type: 'border', color: statusType[params.row.status]}}, status[params.row.status])]
            if (params.row.status === 4) col.push(h('Tooltip', {props: {content: params.row.remarks, placement: 'right'}}, [h('Icon', {props: {type: 'md-alert'}}, status[params.row.status])]))
            return h('div', col)
          }
        },
        {
          title: '操作',
          width: 170,
          fixed: 'right',
          align: 'right',
          render: (h, params) => {
            return h('div', [
              h('Tooltip', {props: {placement: 'right', content: params.row.status === 1 ? '重新发布' : '发布'}}, [
                h('Button', {
                  props: {size: 'small', icon: 'md-play'},
                  on: {
                    click: () => {
                      this.publishData([params.row.id])
                    }
                  }
                })
              ]),
              h('Tooltip', {style: {marginLeft: '3px'}, props: {placement: 'right', disable: params.row.status === 1, content: '撤消发布'}}, [
                h('Button', {
                  props: {size: 'small', icon: 'md-redo'},
                  on: {
                    click: () => {
                      this.undoData(params.row.user_id, params.row.year, params.row.month)
                    }
                  }
                })
              ]),
              h('div', {style: {width: '1px', height: '20px', verticalAlign: 'middle', marginLeft: '3px', display: 'inline-block', borderLeft: '1px solid #eee'}}),
              h('Tooltip', {style: {marginLeft: '3px'}, props: {placement: 'left', content: '更新'}}, [
                h('Button', {
                  props: {size: 'small', icon: 'md-refresh'},
                  on: {
                    click: () => {
                      this.refreshData(params.row.user_id)
                    }
                  }
                })
              ]),
              h('Tooltip', {style: {marginLeft: '3px'}, props: {placement: 'left', content: '删除'}}, [
                h('Button', {
                  props: {size: 'small', icon: 'md-trash'},
                  on: {
                    click: () => {
                      this.deleteData(params.row.id)
                    }
                  }
                })
              ])
            ])
          }
        }
      ]
    }
  },
  watch: {
  },
  components: {
    // draggable
  },
  filters: {
    toFixed (v) {
      return Number(v).toFixed(2)
    }
  },
  mounted () {
    this.fetchData()
    this.$store.dispatch('setDepartment', false)
  },
  methods: {
    createSalary () {
      this.createdSalaryModal = true
    },
    dateChange (date) {
      this.selectDate = date
    },
    pagerChange (page) {
      if (this.params.page !== page) {
        this.params.page = page
        this.fetchData()
      }
    },
    pageSizeChange (size) {
      this.params.page_size = size
      this.fetchData()
    },
    didChange () {
      this.fetchData()
    },
    fetchData () {
      if (this.selectDate === '') {
        this.$Message.error('请选择时间！')
        return
      }
      let date = this.selectDate.split('-')
      let year = date[0]
      let month = date[1]
      this.params.year = year
      this.params.month = month
      this.params.dids = this.selectDids

      fetch('/users/salarys', {params: this.params}).then(res => {
        this.salarys = res.data
        this.attendCount = res.count
      })
    },
    submit () {
      if (this.selectDate === '') {
        this.$Message.error('请选择时间！')
        return
      }
      let date = this.selectDate.split('-')
      let year = date[0]
      let month = date[1]
      this.date = this.selectDate
      this.createStep = 2
      post('/users/salary/create', {year: year, month: month}).then(res => {
        this.createTip = res.msg
        if (res.status === 'success') {
          this.fetchData()
        }
        setTimeout(() => {
          this.createStep = 3
        }, 1500)
      })
    },
    handleClear () {},
    handleOk () {
      this.open = false
      this.date = this.selectDate
      this.fetchData()
    },
    handleClick () {
      this.open = !this.open
    },
    handleSelectAll () {
      this.selectAllStatus = !this.selectAllStatus
      this.$refs.salarysTable.selectAll(this.selectAllStatus)
    },
    selectChange (selection) {
      this.selectIds = []
      this.selectUserIds = []
      if (selection.length > 0) {
        for (var k in selection) {
          if (selection.hasOwnProperty(k)) {
            this.selectIds.push(selection[k].id)
            this.selectUserIds.push(selection[k].user_id)
          }
        }
      }
    },
    publishAllData () {
      this.publishData(this.selectIds)
    },
    publishData (ids) {
      this.$Modal.confirm({
        title: '发布',
        content: '确定发布该薪资数据吗？',
        onOk: () => {
          post('users/salary/data/publish', {ids: ids}).then(res => {
            if (res.status === 'success') {
              this.$Message.success(res.msg)
              this.fetchData()
            } else {
              this.$Message.error(res.msg)
            }
          })
        }
      })
    },
    undoAllData () {
      this.$Modal.confirm({
        title: '撤消',
        content: '确定撤消已发布的薪资数据吗？',
        onOk: () => {
          post('users/salary/data/undo', {ids: this.selectUserIds, year: this.params.year, month: this.params.month}).then(res => {
            if (res.status === 'success') {
              this.$Message.success(res.msg)
              this.fetchData()
            } else {
              this.$Message.error(res.msg)
            }
          })
        }
      })
    },
    undoData (id, year, month) {
      this.$Modal.confirm({
        title: '撤消',
        content: '确定撤消已发布的薪资数据吗？',
        onOk: () => {
          post('users/salary/data/undo', {ids: [id], year: year, month: month}).then(res => {
            if (res.status === 'success') {
              this.$Message.success(res.msg)
              this.fetchData()
            } else {
              this.$Message.error(res.msg)
            }
          })
        }
      })
    },
    refreshData (uid) {
      this.$Modal.confirm({
        title: '更新',
        content: '确定更新该薪资数据吗？',
        onOk: () => {
          post(`users/salary/save/${uid}`, {year: this.params.year, month: this.params.month}).then(res => {
            if (res.status === 'success') {
              this.$Message.success(res.msg)
              this.fetchData()
            } else {
              this.$Message.error(res.msg)
            }
          })
        }
      })
    },
    delData (uid) {
      this.$Modal.confirm({
        title: '删除',
        content: '确定删除该薪资数据吗？',
        onOk: () => {
          console.log(uid)
        }
      })
    },
    upSalaryAttach () {

    },
    setAttach (uid) {
      this.attach.id = 0
      this.attach.value = 0
      this.attach.remarks = ''
      this.attach.user_id = uid
      this.attach.year = this.params.year
      this.attach.month = this.params.month
      this.attachSalaryModal = true
    },
    editAttach (data) {
      this.attach = data
      this.attachSalaryModal = true
    },
    saveAttach () {
      if (Number(this.attach.value) <= 0) {
        this.$Message.error('请输入金额')
        return false
      }
      if (this.attach.remarks === '') {
        this.$Message.error('请输人备注')
        return false
      }
      post('/users/attach/save', this.attach).then(res => {
        if (res.status === 'success') {
          this.$Message.success(res.msg)
          this.fetchData()
          this.attachSalaryModal = false
        } else {
          this.$Message.error(res.msg)
        }
      })
    },
    deleteAttach () {
      this.$Modal.confirm({
        title: '删除',
        content: '确定删除该数据吗？',
        onOk: () => {
          del(`/users/salary/attach/${this.attach.id}`).then(res => {
            if (res.status === 'success') {
              this.$Message.success(res.msg)
              this.fetchData()
              this.attachSalaryModal = false
            } else {
              this.$Message.error(res.msg)
            }
          })
        }
      })
    },
    deleteData (id) {
      this.$Modal.confirm({
        title: '删除',
        content: '确定删除该数据吗？',
        onOk: () => {
          del(`/users/salary/data/${id}`).then(res => {
            if (res.status === 'success') {
              this.$Message.success(res.msg)
              this.fetchData()
              this.attachSalaryModal = false
            } else {
              this.$Message.error(res.msg)
            }
          })
        }
      })
    },
    exportData () {
      post('/users/salary/export', {dids: this.selectDids, ids: this.selectIds, year: this.params.year, month: this.params.month}).then(res => {
        if (res.status === 'success') {
          this.$Message.success('请求成功，请稍等...')
          window.location.href = this.apiPath + `export/salary?cry=${res.cry}`
        } else {
          this.$Message.error(res.msg)
        }
      })
    },
    handleSalarySuccess (res) {
      if (res.status === 'ok') {
        this.uploadState = 0
        this.$Message.success(res.msg)
        this.errors = res.errors
      // this.attendSalaryMonth = res.time
        this.fetchData()
      } else {
        this.$Message.error(res.msg)
      }
    },
    handleFormatError (file) {
      this.$Notice.warning({
        title: '上传错误',
        desc: '您上传的文件可能有误【' + file.name + '】, 请选择xls/xlsx文件.'
      })
    },
    handleMaxSize (file) {
      this.$Notice.warning({
        title: '文件太大',
        desc: '文件  ' + file.name + ' 太大了, 请不要超过 2M.'
      })
    },
    handleBeforeUpload () {
      const check = this.uploadList.length <= 1
      this.uploadState = 1
      if (!check) {
        this.uploadState = 0
        this.$Notice.warning({
          title: '一次只能选择一个文件！'
        })
      }
      return check
    }
  }
}
</script>
<style>
.salary-card .disabled {cursor: no-drop;}
.salary-card .disabled *,
.salary-card .disabled .ivu-card-head p{color:#ccc !important}
.salarys-list{width:2000px}
.salarys-list .salary-item{display:inline-block;width: 120px}
.salarys .price_info{margin-left:10px;font-size:12px;color:blue}
.salarys .highlight{background-color: #fff3e8}
.salarys .ivu-table-cell-ellipsis .ivu-poptip-rel{overflow: hidden;text-overflow: ellipsis;width: 100px;}
.other-salary-td{padding: 0 0 -1px;}
.other-salary-td .other-salary-item{border-bottom: 1px solid #e8eaec;padding: 0 15px;height:48px;line-height: 48px;}
.other-salary-td .other-salary-item:last-child{border:none;}
td.other-salary-td .ivu-table-cell{padding:0}
.did-select .ivu-select-selection{height:24px;overflow:auto;}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.salary-card .item{text-align:right;height: 26px;}
.salary-card .tit{color:#999;float:left}
.spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
</style>
